import store from '@store'

import { initServices } from './services'

export default initServices(store)
